import { camelCase } from 'lodash';

export const PROXY_ROLES = [
  'Employee',
  'Support Employee',
  'Dealer Representative'
];

export const USER_DETAIL_FIELDS = {
  'UNITS_OF_MEASURE_TEMPLATE': 'unitsOfMeasureTemplate',
  'ACCOUNT_COUNTRY': 'accountCountry',
  'ROLES': 'roles',
  'CURRENCY': 'currency',
  'UUID': 'uuid',
  'EMAIL': 'email',
  'DOMAIN': 'domain',
  'USERNAME': 'username'
};

export const FEATURES = [
  'SSURGO'
].reduce((result, key) => { result[key] = key; return result; }, {});

export const COUNTRIES_FOR_FEATURE = {
  'SSURGO': [ 'US' ]
};

export const SCRIPTING_FLAGS = [
  'feature-flag.ol-enabled.phase-1', // OL implementation for select 1st phase legacy APIs including Rogue, operations, fields.
  'cfvweb.feature-flag.cgl',
  'cfvweb.feature-flag.safrina',
  'spa-v2-enable-seed-recommendations',
  'spa-v2-seed-recommendations-indicator',
  'feature-flag.scripting.rx-latam',
  'cfvweb.feature-flag.round-groot', // Rounds Groot coordinates to a fixed precision.
  'script-creator.custom-chemical', // Delaro Script CFVWEB-7974
  'cfvweb.script-creator.custom-fertility-product', // Delaro custom fertility product With Crop Protections
  'sc.productRate-expanded-legend', // FHA Legend - CFVWEB-9778
  'sc.multi-season',
  'cfvweb.script-creator.switch-fertilizer-application-volume-type' // PRDEN-48 Switch between fertilizer/nitrogen inputs
].reduce( (flags, flag) => { flags[flag] = camelCase(flag); return flags; }, {});

export const USER_DOMAINS = {
  PRECISION_PLANTING: 'precision-planting'
};
